// When the window is loaded....
window.addEventListener("load", function () {
	const lineItem = [...document.querySelectorAll(".header_local")];
	lineItem.forEach((arrayElement, index) => {
		setTimeout(function () {
			// console.log(lineItem[index]);
			lineItem[index].classList.add("visible");
		}, 50);
	});

	/*
  var slider_container = document.querySelector('.hero-slider__slide.swiper-slide-active');

  slider_container.addEventListener('click', function() {
    window.location = document.querySelector('.slider_button').getAttribute('href');
    console.log('clicked', window.location)
    return false;
  });
  */

	document.querySelector("body").addEventListener("click", function (e) {
		if (e.target.classList.contains("localization__button") || e.target.classList.contains("collapsible__title"))
			return;
		const actualList = [...document.querySelectorAll(".localization__form")];
		actualList.forEach((arrayElement, index) => {
			actualList[index].classList.remove("collapsible-is-open");
		});
	});

	const mouseTarget = [...document.querySelectorAll("#CountryList")];
	const mainList = [...document.querySelectorAll(".localization__form")];

	mouseTarget.forEach((element) =>
		element.addEventListener("mouseleave", function () {
			mainList.forEach((arrayElement, index) => {
				mainList[index].classList.remove("collapsible-is-open");
			});
		})
	);

	const langTarget = [...document.querySelectorAll("#LanguageList")];

	langTarget.forEach((element) =>
		element.addEventListener("mouseleave", function () {
			mainList.forEach((arrayElement, index) => {
				mainList[index].classList.remove("collapsible-is-open");
			});
		})
	);

	/* usp */
	var swiper = new Swiper(".product-usp-mobile-wrapper", {
		// Default parameters
		slidesPerView: 2,
		loop: true,
		autoplay: {
			delay: 2500,
			disableOnInteraction: false,
		},
	});

	document.querySelector(".menu-drawer__toggle-button").addEventListener("click", function (e) {
		let viewportHeight = window.innerHeight;
		console.log(viewportHeight, "viewport");
		if (window.scrollY > 100) {
			document.querySelector(".js .menu-drawer").style.height = viewportHeight + "px";
			document.querySelector(".menu-drawer__inner-container").style.height = viewportHeight - 50 + "px";
			return;
		}
		document.querySelector(".js .menu-drawer").style.height = "100vh";
		document.querySelector(".menu-drawer__inner-container").style.height = "100vh";
	});
}); // window load
